import { Component, computed, input, ViewEncapsulation } from '@angular/core';

export type FlatButtonColor = 'primary' | 'secondary' | 'warn';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'button[app-flat-button], a[app-flat-button]',
  standalone: true,
  template: `<ng-content />`,
  styleUrl: './flat-button.component.scss',
  host: {
    '[class]': 'classList()',
  },
  encapsulation: ViewEncapsulation.None,
})
export class FlatButtonComponent {
  color = input<FlatButtonColor | null>();

  classList = computed(() => {
    const color = this.color();
    return ['flat-button', color ? `_${color}` : ''].filter(Boolean);
  });
}
